import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const steps = ['Fill order', 'Select time', 'Payment', 'Get confirmation'];

type PropductOrderStepperProps = {
	currentStep: number;
};

const PropductOrderStepper: FC<PropductOrderStepperProps> = ({
	currentStep,
}) => (
	<Box sx={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
		<Stepper activeStep={currentStep}>
			{steps.map((label) => {
				const stepProps: { completed?: boolean } = {};
				const labelProps: {
					optional?: React.ReactNode;
				} = {};
				return (
					<Step key={label} {...stepProps}>
						<StepLabel {...labelProps}>{label}</StepLabel>
					</Step>
				);
			})}
		</Stepper>
	</Box>
);

export default PropductOrderStepper;
